module.exports = __webpack_public_path__ + "static/service_2-fd3ae91aedaf35761ff2d2e77f7f4c0f.jpg";